var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { adminSaveCategorieAsync } from 'admin/store/actions';
import { B64File } from 'common/classes/B64File.class';
import { dispatch } from 'store/store';
/**
 * Categorie d'une annonce
 */
export class AnnonceCategorie {
    /**
     * Constructeur de l'annonceCategorie
     * @param annonceCategorie à construire
     */
    constructor(annonceCategorie) {
        if (annonceCategorie) {
            const { idAnnonceCategorie, idPere, libelle, nomPere, isPremium, url, image, actif, ordre, children, nbAnnonces, } = annonceCategorie;
            this.idAnnonceCategorie = idAnnonceCategorie;
            this.idPere = idPere;
            this.libelle = libelle;
            this.nomPere = nomPere !== null && nomPere !== void 0 ? nomPere : null;
            this.isPremium = isPremium;
            this.image = image !== null && image !== void 0 ? image : (url ? new B64File(B64File.pathUrlToFile(url)) : null);
            this.actif = actif;
            this.ordre = ordre;
            this.children = (children === null || children === void 0 ? void 0 : children.length) > 0 ? children.map((child) => new AnnonceCategorie(child)) : null;
            this.nbAnnonces = nbAnnonces;
        }
    }
    /**
     * Enregistre une catégorie
     */
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            dispatch(adminSaveCategorieAsync(this));
        });
    }
    /**
     * Méthode de renvoie de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        return {
            idAnnonceCategorie: this.idAnnonceCategorie,
            idPere: this.idPere,
            libelle: this.libelle,
            isPremium: this.isPremium,
            file: this.image.toRaw(),
            actif: this.actif,
            ordre: this.ordre,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,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